import { useStore } from "@/context/StoreContext";

const WaIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.3.66 4.54 1.9 6.47L4 29l7.77-1.84a12.1 12.1 0 0 0 4.27.78C22.68 27.94 28 22.58 28 15.97 28 9.36 22.68 3 16.04 3Zm0 21.9c-1.33 0-2.64-.27-3.86-.8l-.55-.24-4.6 1.09 1.1-4.4-.36-.58a9.8 9.8 0 0 1-1.52-5.2c0-5.4 4.4-9.8 9.8-9.8s9.8 4.4 9.8 9.8-4.4 10.13-9.81 10.13Zm5.38-7.3c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.6-.92-2.2-.24-.57-.49-.5-.67-.5h-.57c-.2 0-.52.08-.79.37-.27.3-1.04 1.01-1.04 2.47 0 1.46 1.06 2.87 1.21 3.07.15.2 2.09 3.18 5.06 4.46.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35Z" />
  </svg>
);

export const waLink = (phone, text) => `https://wa.me/91${String(phone || "").replace(/\D/g, "").slice(-10)}?text=${encodeURIComponent(text)}`;

export const WhatsAppFab = () => {
  const { config } = useStore();
  if (!config?.support_phone) return null;
  return (
    <a href={waLink(config.support_phone, "Hi Mukti Fresh, I have a query")} target="_blank" rel="noreferrer" aria-label="Chat with us on WhatsApp"
      className="fixed right-4 bottom-24 sm:bottom-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:scale-105 active:scale-95 transition-transform print:hidden"
      data-testid="whatsapp-fab">
      <WaIcon className="w-8 h-8" />
    </a>
  );
};

const orderText = (o) => [
  `Hi Mukti Fresh, my order ${o.order_number}`,
  `Delivery: ${o.delivery_date} · ${o.slot_label}`,
  ...o.items.filter((i) => i.status !== "unavailable").map((i) => `- ${i.name}${i.cut ? ` (${i.cut})` : ""} x ${i.qty} (${i.unit})`),
  `Amount: Rs ${o.amount_due}`,
].join("\n");

export const ShareOrderWhatsApp = ({ order }) => {
  const { config } = useStore();
  if (!config?.support_phone) return null;
  return (
    <a href={waLink(config.support_phone, orderText(order))} target="_blank" rel="noreferrer"
      className="inline-flex items-center gap-2 h-10 px-4 rounded-full bg-[#25D366] text-white text-sm font-bold hover:bg-[#1ebe5a] active:scale-95 transition-transform"
      data-testid="share-order-whatsapp-btn">
      <WaIcon className="w-5 h-5" /> Share order on WhatsApp
    </a>
  );
};
